export const orgLookupFieldDropdown =  [
  {
    title: "Organization Name",
    value: "organizationName"
  },
  {
    title: "Contact",
    value: "contactName"
  },
  {
    title: "Email",
    value: "contactEmail"
  }

];



// WEBPACK FOOTER //
// ./src/pages/addressBook/filter/organizationLookupFieldDropdown.js